import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/pt-br';
dayjs.locale('pt-br');
dayjs.extend(relativeTime);
export function getDiff({ from, to }) {
    const getDiffBy = (term) => dayjs(to).diff(dayjs(from), term);
    return {
        hours: getDiffBy('hours'),
        minutes: getDiffBy('minutes'),
        seconds: getDiffBy('seconds'),
        days: getDiffBy('days'),
        daysLabel: dayjs(from).to(to || dayjs().unix()),
    };
}
//# sourceMappingURL=getDiff.js.map